import { render } from "./licensed.vue?vue&type=template&id=31ffa920&scoped=true"
import script from "./licensed.vue?vue&type=script&lang=js"
export * from "./licensed.vue?vue&type=script&lang=js"

import "./licensed.vue?vue&type=style&index=0&id=31ffa920&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31ffa920"]])

export default __exports__